import React, { Component } from 'react';
import _ from 'lodash';
import Dropzone from 'react-dropzone';

import './FileUpload.scss';

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  onDrop = (acceptedFiles, rejectedFiles) => {
    if(!_.isEmpty(acceptedFiles)) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const stringData = reader.result;
        this.props.onChange(stringData);
      };
      reader.readAsText(acceptedFiles[0]);
      this.setState({error: null});
    }
    if(!_.isEmpty(rejectedFiles)) {
      if(!_.includes(rejectedFiles[0].type, this.props.accept)) {
        this.setState({error: `Only ${this.props.accept} files allowed.`});
      }
    }
  }

  renderInnerDropzone() {
    if(this.state.error) {
      return (<div className='error'>{this.state.error}</div>);
    } else {
      return (<div>{this.props.buttonText}</div>);
    }
  }

  render() {
    return (
      <div className="file-upload">
        <Dropzone
          activeClassName='uploader-success'
          rejectClassName='uploader-error'
          className='uploader'
          onDrop={this.onDrop}
          multiple={false}
          accept={this.props.accept}
        >
          {this.renderInnerDropzone()}
        </Dropzone>
      </div>
    );
  }
}

export default FileUpload;
